// Explicit preview link only: open the real cart, without adding or changing items.
if (window.location.hash === '#vexora-cart') {
  await customElements.whenDefined('theme-drawer');
  const drawer = document.getElementById('cart-drawer');
  if (drawer && typeof drawer.open === 'function') drawer.open();
}
